/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TextField } from '@mui/material';
import React from 'react';

interface TextFieldDataCustomProps {
    label?: any;
    value?: any;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    helperText?: any;
    type?: 'date' | 'text' | 'number' | 'email' | 'password' | 'tel' | 'url' | 'search' | 'time' | 'datetime-local' | 'month' | 'week';
    margin?: 'dense' | 'normal' | 'none';
    size?: 'small' | 'medium';
    fullWidth?: boolean;
    required?: boolean;
    InputLabelProps?: { shrink: boolean };
    disabled?: boolean;
}

export default function TextFieldDataCustom(
    {
        label,
        value,
        onChange,
        error,
        helperText,
        margin,
        fullWidth,
        required,
        InputLabelProps,
        disabled,
        size = 'medium'
    }: TextFieldDataCustomProps) {
    const handleSetValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log(e.target.value);
        const year = Number(e.target.value.split('-')[0]);
        const mount = e.target.value.split('-')[1];
        const day = e.target.value.split('-')[2];
        if (year > 2200) {

            e.target.value = `2200-${mount}-${day}`;
        }

        onChange!(e);
    }
    return (
        <TextField
            label={label}
            type='date'
            value={value}
            onChange={handleSetValue}
            error={error}
            helperText={helperText}
            fullWidth={fullWidth}
            margin={margin}
            InputLabelProps={InputLabelProps}
            required={required}
            disabled={disabled}
            size={size}
        />
    )
}
